// Per-product OpenLoop intake URL placeholders.
// Replace these with real white-labeled intake links.
export const INTAKE_URLS = {
  glp1: "https://intake.openloophealth.com/meridian/glp1",
  peptides: "https://intake.openloophealth.com/meridian/peptides",
  longevity: "https://intake.openloophealth.com/meridian/longevity",
  hormones: "https://intake.openloophealth.com/meridian/hormones",
  wholeHealth: "https://intake.openloophealth.com/meridian/whole-health",
  microdosing: "https://intake.openloophealth.com/meridian/microdosing",
  default: "https://intake.openloophealth.com/meridian",
} as const;

export type IntakeKey = keyof typeof INTAKE_URLS;

export const PORTAL_URL = "https://portal.openloophealth.com/meridian";
